import React from 'react';
import { EMPTY_FUNCTION } from 'Utils/constants';

const CheckBox = props => {
  const { onClick = EMPTY_FUNCTION, label, isChecked = false, className = '' } = props;

  return (
    <div className={`checkbox ${className}`} onClick={onClick}>
      <div className={`common-check-box ${isChecked ? ' selected' : ''}`}>
        <div className="common-check-box-content">
          <div className="empty-check-box" />
          <div className="common-check-box-svg-wrap">
            <svg width="16" height="14" viewBox="0 0 16 14">
              <path d="M2 8.5L6 12.5L14 1.5" />
            </svg>
          </div>
        </div>
      </div>
      <div className="check-box-label">{label}</div>
    </div>
  );
};

export default CheckBox;
